  <po-page-login
      p-logo="./assets/image/logo-solida.png"
      [p-hide-remember-user]="true"
      p-product-name="Portal Solida"
      [p-loading]="loading"
      [p-password-errors]="passwordErrors"
      [p-login-errors]="loginErrors"
      (p-login-change)="loginChange()"
      (p-password-change)="loginChange()"
      (p-login-submit)="checkLogin($event)"
      [p-literals]="{loginPlaceholder: 'Informe o seu usuario.'}"
    >
    </po-page-login>
